/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { NbAuthService, NbAuthJWTToken, decodeJwtPayload } from "@nebular/auth";
import { NbRoleProvider } from "@nebular/security";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { Injectable } from "@angular/core";
import { UserRole } from "../insurgo-services/constants/user-roles.constant";

@Injectable()
export class RoleProvider extends NbRoleProvider {
  constructor(private authService: NbAuthService) {
    super();
  }

  getRole(): Observable<string | string[]> {
    return this.authService.onTokenChange().pipe(
      map((token: NbAuthJWTToken) => {
        const payload = decodeJwtPayload(token.toString());
        if (token.isValid() && payload && payload["role"]) {
          switch (payload["role"]) {
            case 1:
              return "user";
            case 3:
              return "operations_admin";
            case 9:
              return "admin";
            default:
              return "guest";
          }
        } else {
          return "guest";
        }
      })
    );
  }

  private getCurrentUserRole(): Observable<number> {
    return this.authService.onTokenChange().pipe(
      map((token: NbAuthJWTToken) => {
        const payload = decodeJwtPayload(token.toString());
        if (token.isValid() && payload && payload["role"]) {
          const role =
            typeof payload["role"] === "string"
              ? parseInt(payload["role"])
              : payload["role"];
          return role;
        }
        return 0;
      })
    );
  }

  isStandardUser(): Observable<boolean> {
    return this.getCurrentUserRole().pipe(
      map((role) => role === UserRole.STANDARD)
    );
  }

  isOperationsAdmin(): Observable<boolean> {
    return this.getCurrentUserRole().pipe(
      map((role) => role === UserRole.OPERATIONS_ADMIN)
    );
  }

  isAdmin(): Observable<boolean> {
    return this.getCurrentUserRole().pipe(
      map((role) => role === UserRole.ADMIN)
    );
  }

  hasAdminPrivileges(): Observable<boolean> {
    return this.getCurrentUserRole().pipe(
      map(
        (role) => role === UserRole.ADMIN || role === UserRole.OPERATIONS_ADMIN
      )
    );
  }

  isGuest(): Observable<boolean> {
    return this.getCurrentUserRole().pipe(map((role) => role === 0));
  }
}
